import pricingImg11 from "../assets/new3d/pricingImg11.png";
import pricingImg12 from "../assets/new3d/pricingImg12.png";
import pricingImg13 from "../assets/new3d/pricingImg13.png";
import pricingImg21 from "../assets/new3d/pricingImg21.png";

import productImg11 from "../assets/new3d/productImg11.png";
import productImg12 from "../assets/new3d/productImg12.png";
import productImg13 from "../assets/new3d/productImg13.png";
import productImg21 from "../assets/new3d/productImg21.png";
import productImg22 from "../assets/new3d/productImg22.png";
import productImg23 from "../assets/new3d/productImg23.png";

export default [
  {
    title: "FDM 3D Printing",
    description:
      "Fused Deposition Modeling. FDM 3D printing is the most used, available and affordable 3D printing technology. It has a resolution of 0.1mm-1mm layer height which is very suitable for rapid and low cost prototyping. FDM printing parts, especially PLA, tend to elongate rather than break. Specification of our FDM printing is given below",
    features: [
      {
        name: "Layer Height",
        value: "0.1mm -0.4mm",
      },
      {
        name: "Material",
        value: "PLA, ABS, PETG",
      },
      {
        name: (
          <p>
            Print volume (Max) <br /> Print volume (Min)
          </p>
        ),
        value: ["256mm x 256mm x 256mm ", "230mm x 230mm x 300mm"],
      },
      {
        name: "Color",
        value: "single color. Two color is also possible",
      },
      {
        name: "Temperature sensitivity",
        value:
          "Not suitable for uses in temperatures of over 100 degree celsius.",
      },
      {
        name: "Surface finish",
        value:
          " A bit rough compared to SLA printing. Greater surface finish can be achieved through our post processing service. ",
      },
      {
        name: "Filetype",
        value:
          ".stl, .obj, .3mf, .step, .stp, .igs. (single body part file is needed in case of cad files)",
      },
      {
        name: "Best Use case",
        value: [
          `Low budget and rapid prototyping`,
          `Mechanical Parts`,
          `Functional models`,
          `Cosplay props`,
          `Trial and error`,
          `Low quantity mass production`,
        ],
      },
    ],
    pricing: [
      {
        name: "PLA",
        image: pricingImg11,
        price: "6-10",
        unit: "/gram",
        buildTime: "Build Time: 1 Day",
        data: [
          <p>
            <b>Post processing:</b> depends on model and quantity
          </p>,
          <p>
            <b>
              Pricing may vary depending on model type, material, quantity etc.
            </b>
          </p>,
        ],
      },
      {
        name: "ABS",
        image: pricingImg12,
        price: "8-12",
        unit: "/gram",
        buildTime: "Build Time: 1 Day",
        data: [
          <p>
            <b>Post processing:</b> depends on model and quantity
          </p>,
          <p>
            <b>
              Pricing may vary depending on model type, material, quantity etc.
            </b>
          </p>,
        ],
      },
      {
        name: "PETG",
        image: pricingImg13,
        price: "8-12",
        unit: "/gram",
        buildTime: "Build Time: 1 Day",
        data: [
          <p>
            <b>Post processing:</b> depends on model and quantity
          </p>,
          <p>
            <b>
              Pricing may vary depending on model type, material, quantity etc.
            </b>
          </p>,
        ],
      },
    ],
    notice: "",
    pricingCapabilites: [],
    products: [
      {
        name: "Item 1",
        image: productImg11,
        subheading: "Subheading",
      },
      {
        name: "Item 1",
        image: productImg12,
        subheading: "Subheading",
      },
      {
        name: "Item 1",
        image: productImg13,
        subheading: "Subheading",
      },
    ],
  },
  {
    title: "SLA 3D Printing",
    description:
      "Stereolithography is best used for printing organic shapes and higher resolution models. The hardness of the material is more than FDM printing materials. The material tends to maintain its physical property under stress. Temperature sustainability is more than PLA or ABS. Though it is more costly compared to FDM printing, the quality of the finish is worth it!. The specs are given below:",
    features: [
      {
        name: "Layer Height",
        value: "0.05mm  ",
      },
      {
        name: "Material",
        value:
          "UV resin based plastic (Hard, flexible both option can be printed)",
      },
      {
        name: "Print volume",
        value: (
          <p>
            5.11" x 3.14" x 6.49" (130mm x 80mm x 165mm) Regular( 4k and 2K)
            <br />
            7.55" x 4.72" x 9.84" (192mm x 120mm x 245mm) Max'
          </p>
        ),
      },
      {
        name: "Color",
        value: "Mono color",
      },
      {
        name: "Temperature sensitivity",
        value: "Very fine, no layer line will be visible",
      },
      {
        name: "Surface finish",
        value: "Very fine, no layer line will be visible ",
      },
      {
        name: "Filetype",
        value:
          ".stl, .obj, .3mf, .step, .stp, .igs. (single body part file is needed in case of cad files)",
      },
      {
        name: "Best Use case",
        value: [
          `Smooth organic models`,
          `Mechanical parts`,
          `Product enclosure prototyping`,
          `Action figure`,
          `Scale models`,
          `Cosplay Props`,
          `Mold for silicone molding `,
          `Medical plastic figures`,
        ],
      },
    ],
    pricing: [
      {
        name: "SLA",
        image: pricingImg21,
        price: "12-20",
        unit: "/gram",
        buildTime: "Build Time: 1 Day",
        data: [
          <p>
            <b>Post processing:</b> depends on model and quantity
          </p>,
          <p>
            <b>
              Pricing may vary depending on model type, material, quantity etc.
            </b>
          </p>,
        ],
      },
    ],
    notice: "",
    pricingCapabilites: [],
    products: [
      {
        name: "Item 1",
        image: productImg21,
        subheading: "Subheading",
      },
      {
        name: "Item 1",
        image: productImg22,
        subheading: "Subheading",
      },
      {
        name: "Item 1",
        image: productImg23,
        subheading: "Subheading",
      },
    ],
  },
];
